import React from "react";
import { Box } from "@mui/material";
import i18n from "../../i18n";

import { H2, H6 } from "../../components/typography";
import { COLORS } from "../../theme";
import {imgBack} from "../../assets/images/back";

const QRCode = (props) => {
  const handleBack = () => {
    if (props.handleBack) props.handleBack();
  };

  return (
    <>
      <H2 fontWeight="bold" color={COLORS.white} fontStyle="italic">
        {i18n.t("challenge_friend")}
      </H2>
      <H6 color={COLORS.white}>{i18n.t("scan_qr_code")}</H6>

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 240 },
        }}
        alt="back button"
        src={imgBack}
        onClick={handleBack}
      />
    </>
  );
};

export default QRCode;
